import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-account-details',
  templateUrl: './account-details.component.html',
  styleUrls: ['./account-details.component.scss']
})
export class AccountDetailsComponent implements OnInit {

  constructor() {
    // if(localStorage.getItem('has_onboarded')){
    //   this.router.navigate(['/onboarding/submitted']);
    //   return false;
    // }
  }

  ngOnInit() {}

}
